import React from 'react'

function About() {
    return (
        <div id="about">
            <div id="about-container" className="animated fadeInUp">
                <div className="picture"></div>
                <div className="about-content">
                    <h1>ABOUT US</h1>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam beatae mollitia blanditiis asperiores? Mollitia ratione, facere optio repellendus magnam eum accusantium quaerat vel incidunt adipisci ipsa similique explicabo commodi dolorem exercitationem doloribus voluptates cum quidem pariatur provident officiis, laborum amet? Sint alias, praesentium laboriosam obcaecati libero qui iure quis, ducimus architecto cum voluptates fugit perspiciatis? Reiciendis eaque suscipit a? Minus tempora porro, assumenda esse inventore quam beatae veritatis repellat velit, pariatur obcaecati fugiat! Laboriosam quibusdam ab, dolorem, tempora quidem esse aut libero laborum beatae, perferendis iste. Quod repellendus provident quos facilis enim et, quaerat explicabo sequi quae minus, iusto ipsam.</p>
                </div>
            </div>
        </div>
    )
}

export default About
